import React from 'react';
import ReactDOM from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { AppRouters } from './routes/routes';
import reportWebVitals from './reportWebVitals';
import './index.css'

const queryClient = new QueryClient();

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <AppRouters />
    </QueryClientProvider>
  </React.StrictMode>
);
reportWebVitals();